<template>
  <div style="background-color: #e8eef2">
    <PCNavbar selectIndex="5" />
    <MobileNavBar :currentActive="4" />
    <HangQing />
    <HangQingList />
    <CallMe />
    <MobileCallme />
    <!-- <div
      style="
        cursor: pointer;
        font-size: 2ch;
        position: fixed;
        right: 0;
        top: 50%;
        padding: 0.6vw 1vw;
        color: #fff;
        background: linear-gradient(to right, #792ee7, #04c0cd);
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
      ">
      在线客服
    </div> -->
  </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";
import HangQing from "@/components/hangqinglist/index";
import HangQingList from "@/components/hangqinglist/hqlist";
import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";
// import instance from "../utils/request.js";
export default {
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      // instance
      //   .post("/ApiIndex/loginsub", {
      //     tel: "18888888888",
      //     pwd: "123123",
      //     logintype: 1,
      //   })
      //   .then((res) => {
      //     console.log(res);
      //   });
    },
  },
  components: {
    PCNavbar,
    MobileNavBar,
    HangQing,
    HangQingList,
    CallMe,
    MobileCallme,
  },
};
</script>

<style lang="scss" scoped>
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png),
    url(../assets/img/smalldot1.png);
  background-position: 0 0, 110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }
  .circle_img {
    width: 100%;
    img {
      width: 70%;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20px 0;
      }
    }
  }
}
</style>
